// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ed-z","heading":"Fd-z","items":"Gd-z","featureCss":"Hd-z","disabled":"Id-z","imgCss":"Jd-z"};